import * as React from 'react';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { MastheadPortalId } from '../../../models/AdminModels';
import { useAdminAccountQuery } from '../../../queries';
import { MultiContainerHeader } from '../../../web/components/MultiContainerHeader';
import { BreadcrumbsBarWithNameProvider } from '../../components/blogs/BreadcrumbsBarWithNameProvider';
import { SubadminsPanel } from '../../components/SubadminsPanel';

export const SubadminsPage: React.FC = () => {
	const { accountId } = useParams<{ accountId: string }>();

	const { data: account } = useAdminAccountQuery({
		accountId,
		enabled: !!accountId,
		meta: {
			toastErrorMessage: 'Error loading account',
			errorLogging: {
				category: 'SubadminsPage',
				action: 'GetAdminAccountQuery-Error',
			},
		},
	});

	const impersonationContext = useMemo(() => ({ account: { id: accountId } }), [accountId]);

	return (
		<div className='admin-subadmins-container'>
			<MultiContainerHeader
				appBarHeader={<BreadcrumbsBarWithNameProvider account={account} currentLocation='Subadmins' />}
				appBarPortalDestinationId={MastheadPortalId}
			/>
			<SubadminsPanel impersonationContext={impersonationContext} />
		</div>
	);
};
